var _defs, _rect, _path, _path2, _path3, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgEmeraldBands(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    viewBox: "0 0 1280 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1280,
    y2: 720,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#072D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021812"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "band",
    x1: 50,
    y1: 40,
    x2: 650,
    y2: 640,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22C55E",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F766E",
    stopOpacity: 0.06
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H264L716 720H430L0 0Z",
    fill: "url(#band)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150 0H322L770 720H610L150 0Z",
    fill: "#34D399",
    fillOpacity: 0.18
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M294 0H430L856 720H742L294 0Z",
    fill: "#6EE7B7",
    fillOpacity: 0.08
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1080,
    cy: 146,
    r: 170,
    fill: "#10B981",
    fillOpacity: 0.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgEmeraldBands);
export default __webpack_public_path__ + "static/media/bg-emerald-bands.c0248f47f99d41d2db5a9d4e1323b0c9.svg";
export { ForwardRef as ReactComponent };